package editor.ui

import common.dto.ElementType
import editor.EditorManager
import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.events.Event

// todo docs
object ControlManager {
    /**
     * Creates a control element.
     *
     * @param reversible whether the control can be toggled off. E.g. for "hide". But for bricks controls this should
     *                   be false.
     * @param selectedIcon whether the icon should change when selected
     * @param startSelected whether the control should be selected at the start
     */
    fun TagConsumer<HTMLElement>.control(
        name: String,
        reversible: Boolean = false,
        additionalClasses: Set<String> = emptySet(),
        selectedIcon: Boolean = false,
        startSelected: Boolean = false,
        onClick: (HTMLElement, Event) -> Unit = { _, _ -> },
    ) = div {
        val id = EditorUiHelper.idForName(name)
        fun element() = document.querySelector(".control-$id") as? HTMLElement
        fun isSelected() = element()?.classList?.contains("selected") ?: startSelected
        fun iconSrc() = "icons/$id${if (selectedIcon && isSelected()) "-selected" else ""}.svg"

        onClickFunction = { evt ->
            (evt.currentTarget as? HTMLElement)?.let {
                onClick(it, evt)
                if (selectedIcon) {
                    (it.querySelector("img") as? HTMLImageElement)?.src = iconSrc()
                }
            }
        }
        classes =
            setOf(
                "control-$id",
                id,
                "control",
                "hoverable"
            ) + additionalClasses + (if (reversible) setOf("reversible") else emptySet()) + (if (startSelected) setOf(
                "selected"
            ) else emptySet())
        p { +name }
        img(classes = "icon", src = iconSrc(), alt = name)
    }

    fun TagConsumer<HTMLElement>.brickControl(
        name: String,
        element: ElementType,
        reversible: Boolean = false,
        additionalClasses: Set<String> = emptySet(),
    ) = control(
        name,
        reversible,
        additionalClasses + setOf("brick") + if (EditorManager.toBePlacedType == element) setOf("selected") else emptySet(),
    ) { _, _ ->
        EditorManager.toBePlacedType = element
    }
}